// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.conversation.note.SatelliteWebLandlordNoteHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SatelliteWebLandlordNoteCreateOrUpdateRequestDto, SatelliteWebLandlordNoteDeleteRequestDto } from '../..';

export const SatelliteWebLandlordNoteHandler_createOrUpdate_Path =
  '/api/web/landlord/v1/conversation/note/createOrUpdate';

/**
 * Create or update a conversation's note
 */
export const SatelliteWebLandlordNoteHandler_createOrUpdate = (
  postData: SatelliteWebLandlordNoteCreateOrUpdateRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordNoteCreateOrUpdateRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordNoteHandler_createOrUpdate_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordNoteHandler_delete_Path = '/api/web/landlord/v1/conversation/note/delete';

/**
 * Delete a conversation's note
 */
export const SatelliteWebLandlordNoteHandler_delete = (
  postData: SatelliteWebLandlordNoteDeleteRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordNoteDeleteRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordNoteHandler_delete_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
